import { CaretDownFilled, CaretUpFilled, SyncOutlined } from '@ant-design/icons';
import { TinyArea } from '@ant-design/plots';
import { Col, Dropdown, Menu, Row, Space } from 'antd';
import { isMobile, throttle } from 'app/lib/utils/UiUtils';
import React, { useEffect, useState } from 'react';
import AttentiveIcon from '../../../../static/icons/hub/attentive.svg';
import BlendedIcon from '../../../../static/icons/hub/blended.svg';
import GoogleIcon from '../../../../static/icons/hub/google.svg';
import KlaviyoIcon from '../../../../static/icons/hub/klaviyo.svg';
import layoutIcon from '../../../../static/icons/hub/layout.svg';
import MetaIcon from '../../../../static/icons/hub/meta.svg';
import PinterestIcon from '../../../../static/icons/hub/pinterest.svg';
import ShopifyIcon from '../../../../static/icons/hub/shopify.png';
import TiktokIcon from '../../../../static/icons/hub/tiktok.svg';
import './style.scss';

const menu = (
    <Menu
        items={[
            {
                key: '1',
                label: '1st menu item'
            },
            {
                key: '2',
                label: '2nd menu item'
            }
        ]}
    />
);

const data = [100, 400, 250, 450, 430, 420, 490];

const getConfig = (size) => ({
    height: size === 'lg' ? 150 : size === 'md' ? 100 : 50,
    autoFit: false,
    data,
    smooth: true,
    areaStyle: {
        fill: size === 'lg' ?
            'l(90) 0:rgba(81, 236, 252, 1) 0.1046:rgba(71, 210, 245, 1) 0.3151:rgba(53, 163, 232, 1) 0.5163:rgba(39, 127, 221, 1) 0.703:rgba(29, 101, 214, 1) 0.8698:rgba(23, 85, 210, 1) 1:rgba(21, 79, 208, 1)' :
            'l(90) 0:rgba(81, 236, 252, 1) 0.0918:rgba(71, 215, 245, 1) 0.2835:rgba(54, 176, 232, 1) 0.4733:rgba(40, 145, 221, 1) 0.6584:rgba(30, 124, 214, 1) 0.8366:rgba(24, 110, 210, 1) 1:rgba(22, 106, 208, 1)'
    },
    line: {
        color: '#51ECFC',
        size: 3
    }
});

const gradientColors = {
    y: ['rgba(57, 118, 238, 0.4)', 'rgba(57, 118, 238, 0)']
};

const metaAdsData = [
    { value: '$178,9', title: 'Revenue', isInc: true, percent: '11.26%' },
    { value: '3.78', title: 'ROAS', isInc: true, percent: '3.45%' },
    { value: '0.68', title: 'CPC', isInc: false, percent: '4.21%' },
    { value: '$22', title: 'CPM', isInc: false, percent: '27.51%' },
    { value: '$735,955', title: 'Conversion Value', isInc: false, percent: '77.92%' },
    { value: '$32', title: 'AOV', isInc: false, percent: '27.51%' },
    { value: '$2.76', title: 'CTR', isInc: true, percent: '11.26%' },
    { value: '15,921', title: 'Purchases', isInc: true, percent: '3.45%' },
    { value: '$37.5', title: 'CPA', isInc: false, percent: '4.21%' },
    { value: '$1.09', title: 'CPOC', isInc: false, percent: '27.51%' },
    { value: '8.94', title: 'LTV ROAS', isInc: false, percent: '77.92%' },
    { value: '$109,234', title: 'Spend', isInc: false, percent: '27.51%' }
];

const googleAdsData = [
    { value: '$178,9', title: 'Revenue', isInc: true, percent: '11.26%' },
    { value: '3.78', title: 'ROAS', isInc: true, percent: '3.45%' },
    { value: '0.68', title: 'CPC', isInc: false, percent: '4.21%' },
    { value: '$2.76', title: 'CTR', isInc: true, percent: '11.26%' },
    { value: '15,921', title: 'Purchases', isInc: true, percent: '3.45%' },
    { value: '$37.5', title: 'CPA', isInc: false, percent: '4.21%' }
];

const klaviyoData = [
    { value: '3.78', title: 'ROAS', isInc: true, percent: '3.45%' },
    { value: '0.68', title: 'CPC', isInc: false, percent: '4.21%' },
    { value: '$22', title: 'CPM', isInc: false, percent: '27.51%' },
    { value: '$735,955', title: 'Conversion Value', isInc: false, percent: '77.92%' },
    { value: '$32', title: 'AOV', isInc: false, percent: '27.51%' }
];

const Customize = () => {
    return (
        <Dropdown overlay={menu}>
            <Space>
                Customize
                <img src={layoutIcon} width="14" height="16" style={{ marginBottom: '2px' }} alt="layout icon" />
            </Space>
        </Dropdown>
    );
};

const RefreshButton = () => {
    const [loading, setLoading] = useState(false);

    return (
        <SyncOutlined
            onClick={() => {
                setLoading(!loading);
            }}
            style={{ color: '#337AED', stroke: '#337AED', fontSize: '25px', strokeWidth: '30' }}
            spin={loading}
        />
    );
};

const GradientCard = ({ style, children }) => {
    return (
        <div className="grad-card" style={style}>
            {children}
        </div>
    );
};

const StatCardLg = ({ Icon, title, value, isInc, percent, style }) => {
    return (
        <GradientCard style={style}>
            <div className="stat-card-title">
                {Icon} {title}
            </div>
            <TinyArea {...getConfig('lg')} style={{ width: '100%' }} />
            <h1>{value}</h1>
            <div className="percent-status" style={{ color: isInc ? '#14EF90' : '#F98CA6' }}>
                {isInc ? <CaretUpFilled /> : <CaretDownFilled />}
                {percent}
            </div>
        </GradientCard>
    );
};

const StatCardSm = ({ value, title, isInc, percent, style }) => {
    return (
        <GradientCard style={style}>
            <TinyArea {...getConfig('sm')} style={{ width: '120px', margin: 'auto' }} />
            <h3>{value}</h3>
            <h5>{title}</h5>
            <div className="percent-status-sm" style={{ color: isInc ? '#14EF90' : '#F98CA6' }}>
                {isInc ? <CaretUpFilled /> : <CaretDownFilled />}
                {percent}
            </div>
        </GradientCard>
    );
};

const HUB = () => {
    const [mobile, setMobile] = useState(isMobile());
    const [dateRange, setDateRange] = useState([moment(), moment()]);
    console.log('view:', mobile);
    const handleResize = throttle(() => setMobile(isMobile()));

    useEffect(() => {
        console.log('daterange change:', dateRange);
    }, [dateRange]);

    return (
        <div className="hub-bk">
            <div className="hub-hd">
                <span style={{ width: 'fit-content' }}>
                    {!mobile && <DateRangePicker dateRange={dateRange} onSetDateRange={(r) => setDateRange(r.dates)} />}
                    <Customize />
                </span>
                <div className="refresh">
                    {!mobile && <>Updated just now</>}
                    <RefreshButton />
                </div>
            </div>
            {mobile && <div style={{ marginTop: "10px" }}>
                <DateRangePicker dateRange={dateRange} onSetDateRange={(r) => setDateRange(r.dates)} />
            </div>}
            <div className="hub-bd">
                <Row gutter={40}>
                    <Col span={mobile ? 24 : 12}>
                        <StatCardLg
                            Icon={<img src={ShopifyIcon} width="30" height="30" style={{ marginRight: '20px' }} alt="shopify icon" />}
                            title="Shopify Sales"
                            value="$178,900"
                            isInc={true}
                            percent="11.26%"
                            style={{
                                background:
                                    'linear-gradient(180.21deg, rgba(21, 149, 208, 1) 15.22%, rgba(21, 129, 208, 1) 24.99%, rgba(21, 103, 208, 1) 40.85%, rgba(21, 84, 208, 1) 57.13%, rgba(21, 73, 208, 1) 73.94%, rgba(21, 69, 208, 1) 92.08%)'
                            }}
                        />
                    </Col>
                    <Col span={mobile ? 24 : 12}>
                        <StatCardLg
                            Icon={<img src={BlendedIcon} width="30" height="30" style={{ marginRight: '20px' }} alt="blended icon" />}
                            title="Blended ROAS"
                            value="5.7"
                            isInc={true}
                            percent="11.26%"
                            style={{
                                marginTop: mobile ? '20px' : '0px',
                                background:
                                    'linear-gradient(180.21deg, rgba(21, 149, 208, 1) 15.22%, rgba(21, 129, 208, 1) 24.99%, rgba(21, 103, 208, 1) 40.85%, rgba(21, 84, 208, 1) 57.13%, rgba(21, 73, 208, 1) 73.94%, rgba(21, 69, 208, 1) 92.08%)'
                            }}
                        />
                    </Col>
                </Row>
                <GradientCard
                    style={{
                        marginTop: mobile ? '24px' : '40px',
                        padding: mobile ? "25px 16px" : "25px 40px",
                        background:
                            'linear-gradient(180.21deg, rgba(21, 149, 208, 0.62) 15.22%, rgba(21, 129, 208, 0.62) 24.99%, rgba(21, 103, 208, 0.62) 40.85%, rgba(21, 84, 208, 0.62) 57.13%, rgba(21, 73, 208, 0.62) 73.94%, rgba(21, 69, 208, 0.62) 92.08%)'
                    }}>
                    <div className="stat-card-title" style={{ marginBottom: '20px' }}>
                        <img src={MetaIcon} width="30" height="30" style={{ marginRight: '20px' }} alt="meta icon" /> Meta Ads
                    </div>
                    <Row gutter={mobile ? 8 : 24}>
                        {metaAdsData.map((item) => (
                            <Col span={mobile ? 12 : 4} style={{ marginBottom: mobile ? '12px' : '36px' }}>
                                <StatCardSm
                                    title={item.title}
                                    value={item.value}
                                    isInc={item.isInc}
                                    percent={item.percent}
                                    style={{
                                        padding: mobile ? "25px 16px" : "25px 40px",
                                        background:
                                            'linear-gradient(180.21deg, rgba(21, 149, 208, 1) 15.22%, rgba(21, 129, 208, 1) 24.99%, rgba(21, 103, 208, 1) 40.85%, rgba(21, 84, 208, 1) 57.13%, rgba(21, 73, 208, 1) 73.94%, rgba(21, 69, 208, 1) 92.08%)'
                                    }}
                                />
                            </Col>
                        ))}
                    </Row>
                </GradientCard>
                <GradientCard
                    style={{
                        marginTop: mobile ? '24px' : '40px',
                        padding: mobile ? "25px 16px" : "25px 40px",
                        background:
                            'linear-gradient(180.21deg, rgba(21, 149, 208, 0.62) 15.22%, rgba(21, 129, 208, 0.62) 24.99%, rgba(21, 103, 208, 0.62) 40.85%, rgba(21, 84, 208, 0.62) 57.13%, rgba(21, 73, 208, 0.62) 73.94%, rgba(21, 69, 208, 0.62) 92.08%)'
                    }}>
                    <div className="stat-card-title" style={{ marginBottom: '20px' }}>
                        <img src={GoogleIcon} width="30" height="30" style={{ marginRight: '20px' }} alt="google icon" /> Google Ads
                    </div>
                    <Row gutter={mobile ? 8 : 24}>
                        {googleAdsData.map((item) => (
                            <Col span={mobile ? 12 : 4} style={{ marginBottom: mobile ? '12px' : '36px' }}>
                                <StatCardSm
                                    title={item.title}
                                    value={item.value}
                                    isInc={item.isInc}
                                    percent={item.percent}
                                    style={{
                                        padding: mobile ? "25px 16px" : "25px 40px",
                                        background:
                                            'linear-gradient(180.21deg, rgba(21, 149, 208, 1) 15.22%, rgba(21, 129, 208, 1) 24.99%, rgba(21, 103, 208, 1) 40.85%, rgba(21, 84, 208, 1) 57.13%, rgba(21, 73, 208, 1) 73.94%, rgba(21, 69, 208, 1) 92.08%)'
                                    }}
                                />
                            </Col>
                        ))}
                    </Row>
                </GradientCard>
                <GradientCard
                    style={{
                        marginTop: mobile ? '24px' : '40px',
                        padding: mobile ? "25px 16px" : "25px 40px",
                        background:
                            'linear-gradient(180.21deg, rgba(21, 149, 208, 0.62) 15.22%, rgba(21, 129, 208, 0.62) 24.99%, rgba(21, 103, 208, 0.62) 40.85%, rgba(21, 84, 208, 0.62) 57.13%, rgba(21, 73, 208, 0.62) 73.94%, rgba(21, 69, 208, 0.62) 92.08%)'
                    }}>
                    <div className="stat-card-title" style={{ marginBottom: '20px' }}>
                        <img src={KlaviyoIcon} width="30" height="30" style={{ marginRight: '20px' }} alt="klaviyo icon" /> Klaviyo
                    </div>
                    <Row gutter={mobile ? 8 : 24}>
                        {klaviyoData.map((item, idx) => (
                            <Col style={{ marginBottom: mobile ? '12px' : '36px', width: mobile ? (idx !== 4 ? '50%' : '100%') : '20%' }}>
                                <StatCardSm
                                    title={item.title}
                                    value={item.value}
                                    isInc={item.isInc}
                                    percent={item.percent}
                                    style={{
                                        padding: mobile ? "25px 16px" : "25px 40px",
                                        background:
                                            'linear-gradient(180.21deg, rgba(21, 149, 208, 1) 15.22%, rgba(21, 129, 208, 1) 24.99%, rgba(21, 103, 208, 1) 40.85%, rgba(21, 84, 208, 1) 57.13%, rgba(21, 73, 208, 1) 73.94%, rgba(21, 69, 208, 1) 92.08%)'
                                    }}
                                />
                            </Col>
                        ))}
                    </Row>
                </GradientCard>
                <Row
                    gutter={40}
                    style={{
                        marginTop: mobile ? '24px' : '40px',
                    }}>
                    <Col span={mobile ? 24 : 8}>
                        <StatCardLg
                            Icon={<img src={TiktokIcon} width="30" height="30" style={{ marginRight: '20px' }} alt="tiktok icon" />}
                            title="TikTok ROAS"
                            value="3.78"
                            isInc={true}
                            percent="3.45%"
                            style={{
                                marginBottom: '20px',
                                background:
                                    'linear-gradient(180.21deg, rgba(21, 149, 208, 1) 15.22%, rgba(21, 129, 208, 1) 24.99%, rgba(21, 103, 208, 1) 40.85%, rgba(21, 84, 208, 1) 57.13%, rgba(21, 73, 208, 1) 73.94%, rgba(21, 69, 208, 1) 92.08%)'
                            }}
                        />
                    </Col>
                    <Col span={mobile ? 24 : 8}>
                        <StatCardLg
                            Icon={<img src={AttentiveIcon} width="30" height="30" style={{ marginRight: '20px' }} alt="attentive icon" />}
                            title="Attentive Revenue"
                            value="$9,32"
                            isInc={true}
                            percent="3.45%"
                            style={{
                                marginBottom: '20px',
                                background:
                                    'linear-gradient(180.21deg, rgba(21, 149, 208, 1) 15.22%, rgba(21, 129, 208, 1) 24.99%, rgba(21, 103, 208, 1) 40.85%, rgba(21, 84, 208, 1) 57.13%, rgba(21, 73, 208, 1) 73.94%, rgba(21, 69, 208, 1) 92.08%)'
                            }}
                        />
                    </Col>
                    <Col span={mobile ? 24 : 8}>
                        <StatCardLg
                            Icon={<img src={PinterestIcon} width="30" height="30" style={{ marginRight: '20px' }} alt="pinterest icon" />}
                            title="Pinterest ROAS"
                            value="2.10"
                            isInc={true}
                            percent="3.45%"
                            style={{
                                marginBottom: '20px',
                                background:
                                    'linear-gradient(180.21deg, rgba(21, 149, 208, 1) 15.22%, rgba(21, 129, 208, 1) 24.99%, rgba(21, 103, 208, 1) 40.85%, rgba(21, 84, 208, 1) 57.13%, rgba(21, 73, 208, 1) 73.94%, rgba(21, 69, 208, 1) 92.08%)'
                            }}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default HUB;
